export default {"src":"/_next/static/media/menu.7dff93b2.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};